import React, { Component } from "react";
import _ from "lodash";
import { Tab, Accordion } from "semantic-ui-react";
import { connect } from "react-redux";
import SearchResultHeader from "./SearchResultHeader";
import {getMenuItem} from "../common/PageHelper";
import ShowAllElements from "../reports/Silver/ShowAllElements";

class CorporationsAndBusinessesNimbusResult extends Component {
  constructor(props) {
    super(props);
    const { internalID, savedResultID } = props.additionalData;
    this.state = {
      activeIndex: 0,
      savedResultID,
      internalID,
    };
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };
  
  render() {
    // const { searchResultData } = this.props;
    //     const rowTables = [];
    //     let recCount = 0;
    //     const root = Object.keys(searchResultData)[0];
    //     const corporations = _.get(searchResultData, `${root}.output[0].corporations[0].corporation`);
    //     if (corporations) {
    //       if (corporations && corporations.length > 0) {
    //         _.forEach(corporations, (record, index) => {
    //           const recs = [];
    //           getAllRows(
    //             record,
    //             recs,
    //             props,
    //             _.get(record, "$.display"),
    //             0,
    //             undefined,
    //             true
    //           );
    //           if (recs.length > 0) {
    //             rowTables.push(
    //               <Table.Row key={`${props.sectionName}_${index}`}>
    //                 <Table.Cell>
    //                   <Table>
    //                     <Table.Body>
    //                       <Table.Row>
    //                         <Table.HeaderCell
    //                           colSpan={2}
    //                           className="report-sub-section-header"
    //                         >
    //                           Record
    //                         </Table.HeaderCell>
    //                       </Table.Row>
    //                       {recs}
    //                     </Table.Body>
    //                   </Table>
    //                 </Table.Cell>
    //               </Table.Row>
    //             );
    //           }
    //         });
    //         recCount = rowTables.length;
    //       } else {
    //         rowTables.push(
    //           <Table.Row key={`no_recs_row`}>
    //             <Table.Cell colSpan={2}>No Records found</Table.Cell>
    //           </Table.Row>
    //         );
    //       }
    //     }
    const tabs = [];
    const { userAccount, searchResultData, updateItemCountBySection } = this.props;
    const root = Object.keys(searchResultData)[0];
    let tabHeader = null;
    const recordsCount = _.get(
            this.props.searchResultData,
            `${Object.keys(this.props.searchResultData)[0]}.log[0].actCode[0]`
          );
    if (
      searchResultData !== undefined &&
      searchResultData !== null &&
      searchResultData !== ""
    ) {
      const records = _.get(
        searchResultData,
        `${root}.response[0]output[0].corporations[0].corporation`
      );

      const showNarrowSearchMessage = records && records.length > 25;
      tabHeader = (
        <SearchResultHeader
          showNarrowSearchMessage={showNarrowSearchMessage}
          log={_.get(
            this.props.searchResultData,
            `${Object.keys(this.props.searchResultData)[0]}.log[0]`
          )}
          {...this.props}
          printContent={this.props.printContent}
        />
      );
    }  
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${recordsCount > 0 ? recordsCount : 0} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {tabHeader}
      <Accordion fluid styled id={`nav_${this.props.sectionName}`}>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`Rep_Corporations_Title`}
          onClick={() => this.handleClick()}
        >
          <p>
            Corporations and Businesses
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`Rep_Corporations_Body`}
          active={this.state.activeIndex === 0}
        >
          <ShowAllElements
            {...this.props}
            level={4}
            sectionName={"Corporations"}
            sectionTitle={"Corporations"}
            node={_.get(
              searchResultData,
              `${root}.response[0]output[0].corporations[0].corporation`
            )}
            key={`rep_corporations`}
            updateItemCountBySection={updateItemCountBySection}
          />
          <ShowAllElements
            {...this.props}
            level={4}
            sectionName={"Businesses"}
            sectionTitle={"Businesses"}
            node={_.get(
              searchResultData,
              `${root}.response[0]output[0].businesses[0].business`
            )}
            key={`rep_businesses`}
            updateItemCountBySection={updateItemCountBySection}
          />
        </Accordion.Content>
      </Accordion>
        </Tab.Pane>
      ),
    });

    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount, uiData: state.uiData };
}

export default connect(mapStateToProps, null)(CorporationsAndBusinessesNimbusResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/CorporationsAndBusinessesNimbusResult.js